/* Mossante storefront behaviour.
   One file, no framework, no build step. Everything here runs against markup the
   Liquid sections emit, so the contract between the two is load-bearing: if an
   attribute below is renamed in a section, this file must change in the same
   commit. A missing `=` on data-colours once silently disabled the whole picker. */
(function () {
  'use strict';

  /* Prices print in the shopper's currency (2026-09-24). Liquid and the cart
     already give amounts in the presentment currency, converted and rounded by
     Markets, which are the numbers checkout charges; this only picks the symbol.
     USD keeps the house style ($55, $69.50). Every page script and the cart
     carry the same two functions, so keep them identical. */
  var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  /* DP: the currency's own decimals (0 for JPY, KRW; 2 for EUR, AUD). Shopify's
     amounts are always in hundredths, so a zero-decimal currency is rounded to a
     whole unit here, or "3 for 2" would print ¥5,933.33 each (review 2026-09-24). */
  var DP = 2;
  try { DP = new Intl.NumberFormat('en', { style: 'currency', currency: CUR }).resolvedOptions().maximumFractionDigits; } catch (e) {}
  if (DP > 2) DP = 2;
  var money = function (cents) {
    var v = cents / 100;
    if (CUR === 'USD') return '$' + (v % 1 ? v.toFixed(2) : v);
    if (DP === 0) v = Math.round(v);
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: CUR,
        minimumFractionDigits: v % 1 ? DP : 0, maximumFractionDigits: DP }).format(v);
    } catch (e) { return CUR + ' ' + (v % 1 ? v.toFixed(DP) : v); }
  };

  /* data-offers holds the offer prices as typed in the theme editor, in the shop
     currency (USD), plus "base": the product's price as Liquid rendered it for
     this shopper, already converted and rounded by Markets. In any other
     currency the full price becomes base, and a lower offer price (the pair
     price) keeps its USD discount converted at the storefront rate, which is how
     Shopify converts a fixed-amount discount at checkout. In USD nothing moves. */
  function localOffers(offers) {
    if (CUR === 'USD' || !offers || !offers.length) return offers;
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 0;
    var top = 0;
    offers.forEach(function (o) { if (o.unit > top) top = o.unit; });
    return offers.map(function (o) {
      var c = {}, k;
      for (k in o) if (Object.prototype.hasOwnProperty.call(o, k)) c[k] = o[k];
      /* Shopify rounds a converted fixed discount to the currency's smallest unit
         (a whole yen is 100 here), so round the same way or JPY pairs miss by <1 yen. */
      var step = Math.pow(10, 2 - DP);
      if (o.base) c.unit = o.base - Math.round((top - o.unit) * rate / step) * step;
      else if (rate) c.unit = Math.round(o.unit * rate / step) * step;
      return c;
    });
  }

  var req = function (url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  };

  /* ---------- carousel ---------- */
  function carousel(root) {
    var track = root.querySelector('[data-trk]');
    if (!track) return;
    var cells = track.children;
    var nOf = function () { return cells.length; };
    var prev = root.querySelector('[data-prev]'),
        next = root.querySelector('[data-next]'),
        dots = root.querySelector('[data-dots]');

    var gapOf = function () {
      return parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
    };
    var step = function () { return cells[0] ? cells[0].getBoundingClientRect().width + gapOf() : 300; };
    var idx  = function () { return Math.round(track.scrollLeft / step()); };
    var go   = function (i) {
      i = Math.max(0, Math.min(nOf() - 1, i));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    };

    if (dots && !dots.children.length) {
      for (var i = 0; i < nOf(); i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dt';
        b.setAttribute('aria-label', 'Go to ' + (i + 1));
        (function (k) { b.onclick = function () { go(k); }; })(i);
        dots.appendChild(b);
      }
    }
    if (prev) prev.onclick = function () { go(idx() - 1); };
    if (next) next.onclick = function () { go(idx() + 1); };

    var t = 0;
    function sync() {
      var i = idx();
      if (dots) [].forEach.call(dots.children, function (d, j) {
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= nOf() - 1;
    }

    /* buildStage() re-enters this function on every colour change. Binding again
       each pass stacked a fresh set of listeners on the same track - ten taps meant
       ten scroll handlers and ten timers per scroll event, which is why the page
       degraded the more it was touched. Bind once; later passes only re-sync. */
    if (track._moBound) { sync(); return; }
    track._moBound = 1;

    /* a timeout, not requestAnimationFrame: rAF is paused in a background tab and
       the dots would silently stop tracking */
    track.addEventListener('scroll', function () {
      if (t) return; t = setTimeout(function () { t = 0; sync(); }, 60);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(idx() - 1); }
    });
    var down = false, sx = 0, sl = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('dragging'); track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; moved = Math.abs(dx); track.scrollLeft = sl - dx;
    });
    var up = function () {
      if (!down) return;
      down = false; track.classList.remove('dragging');
      if (moved > 6) go(idx());
    };
    track.addEventListener('pointerup', up);
    track.addEventListener('pointercancel', up);
    track.addEventListener('click', function (e) { if (moved > 6) e.preventDefault(); }, true);
    sync();
  }

  /* ---------- reveal on scroll ---------- */
  function reveals() {
    var els = [].slice.call(document.querySelectorAll('.mo .rv:not(.seen)'));
    if (!els.length) return;
    function pass() {
      var h = window.innerHeight;
      for (var i = els.length - 1; i >= 0; i--) {
        if (els[i].getBoundingClientRect().top < h * 1.06) {
          els[i].classList.add('seen');
          [].forEach.call(els[i].querySelectorAll('.bf[data-w]'), function (f) {
            setTimeout(function () { f.style.width = f.dataset.w + '%'; }, 20);
          });
          els.splice(i, 1);
        }
      }
    }
    var t = 0, kick = function () { if (t) return; t = setTimeout(function () { t = 0; pass(); }, 50); };
    addEventListener('scroll', kick, { passive: true });
    addEventListener('resize', kick);
    document.addEventListener('visibilitychange', kick);
    pass(); setTimeout(pass, 120); setTimeout(pass, 600);
    /* a hard backstop: nothing may stay invisible because an observer missed it */
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('.mo .rv'), function (e) { e.classList.add('seen'); });
    }, 3000);
  }

  /* ---------- picker ----------
     Three offers, one colour choice per bracelet in the bundle.

     Prices here are DISPLAY ONLY. Every bracelet is added to the cart at full
     price and Shopify's automatic "Buy 2, get 1 free" discount makes the free ones
     free - unlimited per order, so 3 bills 2 and 6 bills 4 without the theme ever
     sending a discounted price. The storefront previously advertised a volume
     ladder that no discount existed to honour; never reintroduce that. */
  function picker(root) {
    var rawColours = root.getAttribute('data-colours');
    if (rawColours === null) {
      console.error('[mossante] picker: no data-colours attribute. Check it is written ' +
        'name="value" - a missing = makes the browser parse a valueless attribute.');
      return;
    }
    var data = [];
    try { data = JSON.parse(rawColours) || []; }
    catch (err) {
      console.error('[mossante] picker: data-colours is not valid JSON.', err, rawColours.slice(0, 300));
      return;
    }
    if (!data.length) { console.error('[mossante] picker: no colours. Does the product have variants?'); return; }

    /* Merchandising order without touching the product: reordering variants would
       move option positions and ripple into inventory and saved discount rules. */
    var wanted = (root.getAttribute('data-order') || '').split(',')
      .map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    if (wanted.length) {
      var byKey = {};
      data.forEach(function (c) { byKey[String(c.id).toLowerCase()] = c; });
      var ordered = [], taken = {};
      wanted.forEach(function (k) { if (byKey[k] && !taken[k]) { ordered.push(byKey[k]); taken[k] = 1; } });
      data.forEach(function (c) { if (!taken[String(c.id).toLowerCase()]) ordered.push(c); });
      if (ordered.length === data.length) data = ordered;
    }

    var offers = [];
    try { offers = localOffers(JSON.parse(root.getAttribute('data-offers') || '[]') || []); } catch (e) { offers = []; }
    if (!offers.length) offers = [{ pay: 1, free: 0, unit: 5500, badge: '' }];

    /* Open on the middle offer where one exists. Defaulting to a single makes the
       bundle read as an upsell instead of the ordinary way to buy. */
    /* The single bracelet starts selected, so the price on screen is the price
       of the thing being looked at and the button is live from the first frame.
       The bigger offers are the shopper's own upgrade, one tap away. */
    var tier = 0;
    function maxN() {
      var m = 1;
      offers.forEach(function (o) { var t = totalOf(o); if (t > m) m = t; });
      return m;
    }
    function capN() { return tier >= 0 ? totalOf(offers[tier]) : maxN(); }
    var view = 0;

    var stage    = root.querySelector('[data-stage]');
    var forEl    = root.querySelector('[data-for]');
    var nameEl   = root.querySelector('[data-colname]');
    var offersUI = root.querySelector('[data-offers-ui]');
    var swg      = root.querySelector('[data-swg]');
    var addBtn   = root.querySelector('[data-add]');
    var hintEl   = root.querySelector('[data-hint]');
    var readEl   = root.querySelector('[data-read]');
    var resetEl  = root.querySelector('[data-reset]');
    var rsBox    = root.querySelector('[data-restock]');
    var rsHead   = root.querySelector('[data-rs-head]');
    var rsPre    = root.querySelector('[data-rs-pre]');
    var rsTags   = root.querySelector('[data-rs-tags]');
    var rsForm   = rsBox ? rsBox.querySelector('form') : null;
    var RDATE    = (root.getAttribute('data-restock-date') || '').trim();
    /* What one option is called in the hint and the offer card. The picker's
       "word" setting (data-word) names it on a product funnel (the Solitaire:
       "style", cut and finish in one option); absent, it is the cord's
       "colour", so the cord page is unchanged (2026-09-30). */
    var WORD     = (root.getAttribute('data-word') || '').replace(/^\s+|\s+$/g, '') || 'colour';
    /* The waitlist tag base comes from the form Liquid rendered: waitlist-cord
       on the cord, waitlist-<handle> elsewhere. The option id is slugged, so
       "round, silver" is one tag and not two (tags are comma-separated). */
    var WLTAG    = 'waitlist-cord';
    if (rsTags) {
      var wl0 = String(rsTags.defaultValue || rsTags.value || '').split(',')[1];
      if (wl0 && wl0.replace(/^\s+|\s+$/g, '')) WLTAG = wl0.replace(/^\s+|\s+$/g, '');
    }
    function slug(x) { return String(x).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

    /* A waitlist-only colour can be on screen, but it can never be ordered, so it
       must never be what "the rest gets the colour on screen" fills with. */
    function orderable(i) { return !!data[i] && data[i].available !== false; }
    function fillIdx() {
      if (orderable(view)) return view;
      for (var k = queue.length - 1; k >= 0; k--) if (orderable(queue[k])) return queue[k];
      for (k = 0; k < data.length; k++) if (orderable(k)) return k;
      return view;
    }

    /* Deep link: /?colour=gold opens on that colour (Adelyte sends this to customers
       asking about a restock). After the waitlist form posts back, reopen on the
       colour the shopper signed up for. */
    (function () {
      var m = /[?&]colou?r=([^&#]+)/i.exec(location.search), want = m ? decodeURIComponent(m[1]).toLowerCase() : '';
      /* ?variant=<id> is how Shopify, catalog ads and the cart's product links
         name one option: open on it (2026-09-30). The cord page is "/" and is
         never linked that way, so it is unchanged. */
      var mv = /[?&]variant=(\d+)/.exec(location.search);
      if (!want && mv) {
        for (var j = 0; j < data.length; j++) if (String(data[j].variant) === mv[1]) { view = j; return; }
      }
      if (!want && rsBox && (rsBox.querySelector('[data-rs-ok]') || rsBox.querySelector('[data-rs-err]'))) {
        try { want = sessionStorage.getItem('moRestock') || ''; } catch (e) { want = ''; }
      }
      if (!want) {
        /* Nobody asked for a colour: open on one that can be ordered, so an ad
           click never lands on a sold-out bracelet (Gold is first in the order). */
        if (!orderable(view) || data[view].preorder) {
          for (var k = 0; k < data.length; k++) if (orderable(k) && !data[k].preorder) { view = k; break; }
        }
        return;
      }
      data.forEach(function (c, i) {
        if (String(c.id).toLowerCase() === want || String(c.name).toLowerCase() === want) view = i;
      });
    })();
    if (rsForm) rsForm.addEventListener('submit', function () {
      var c = data[view] || {};
      if (rsTags) rsTags.value = 'waitlist,' + WLTAG + (c.id ? ',' + WLTAG + '-' + slug(c.id) : '');
      try { sessionStorage.setItem('moRestock', String(c.id || '')); } catch (e) {}
    });

    function totalOf(o) { return o.pay + o.free; }
    function payCents(o) { return o.pay * o.unit; }
    function fullCents(o) { return totalOf(o) * o.unit; }

    /* Write only when the value actually changed: an identical innerHTML
       assignment still tears down and reparses the subtree. */
    function setHTML(el, html) { if (el && el._h !== html) { el._h = html; el.innerHTML = html; } }
    function setText(el, txt)  { if (el && el._t !== txt)  { el._t = txt;  el.textContent = txt; } }

    if (offersUI) {
      offers.forEach(function (o, i) {
        var n = totalOf(o), pay = payCents(o), full = fullCents(o);
        var el = document.createElement('button');
        el.type = 'button'; el.className = 'offer'; el.setAttribute('role', 'radio');
        el.innerHTML =
          '<span class="offRadio" aria-hidden="true"></span>' +
          '<span class="offMain">' +
            '<span class="offTitle">' +
              (o.free ? 'Buy ' + o.pay + ', get ' + o.free + ' free'
                      : n + (n === 1 ? ' bracelet' : ' bracelets')) +
            '</span>' +
            '<span class="offSub">' +
              (o.free ? n + ' bracelets &middot; ' + money(Math.round(pay / n)) + ' each'
                      : 'Pick any ' + WORD) +
            '</span>' +
          '</span>' +
          '<span class="offPrice"><b class="nm">' + money(pay) + '</b>' +
            (o.free ? '<s class="nm">' + money(full) + '</s>' : '') + '</span>' +
          (o.badge ? '<span class="offBadge">' + o.badge + '</span>' : '');
        /* Never wipe the choice on an offer change - that punishes exploring the
           ladder, which is the upsell itself. A bigger offer just leaves room to
           fill; a smaller one keeps the newest N. */
        el.onclick = function () {
          tier = i;
          var n = totalOf(offers[tier]);
          if (queue.length > n) queue = queue.slice(queue.length - n);
          paint();
        };
        offersUI.appendChild(el);
      });
    }

    /* The colours as pictures, under the image. Tapping one previews it; which
       bracelet gets which colour is decided in the bag, where a shopper can see
       the whole order at once. */
    /* THE RULE, entire: your bag is your last N taps.

       Starts EMPTY - nothing is ever chosen on the shopper's behalf, and Reset
       returns it to empty. Taps fill it; only once it is FULL does a tap start
       evicting the oldest. So "tap the 3 I want" is literally what happens, and
       tapping one twice gives two of it. No minus buttons: the offer fixes the
       total at N, so a shopper never wants fewer, and "remove" never needs a
       control of its own. Whatever is still unpicked when they hit Add is filled
       with the colour on screen, which is why the button is never dead. */
    var queue = [];
    var touched = false;

    function clear() { queue = []; }
    function counts() {
      var m = [], i;
      for (i = 0; i < data.length; i++) m.push(0);
      for (i = 0; i < queue.length; i++) m[queue[i]]++;
      return m;
    }
    /* Grouped in queue order, oldest first, so the readout is stable as taps land. */
    function mix() {
      var seen = [], m = {}, i, k;
      for (i = 0; i < queue.length; i++) {
        k = queue[i];
        if (m[k] === undefined) { m[k] = 0; seen.push(k); }
        m[k]++;
      }
      return seen.map(function (j) { return m[j] + '× ' + data[j].name; }).join(' &middot; ');
    }

    /* A two-part option ("Round, gold plated") is two lines on its chip: the
       cut, then the finish. A 10px label wrapped mid-finish otherwise
       ("Round, gold / plated"). One-word colours are untouched (2026-09-30). */
    function chipName(nm) { return String(nm).replace(/,\s*/, '<br>'); }

    /* Finish first, then cut (Lukas, 2026-10-07: twelve chips was too much to scan).
       When the picker is told to group (data-group="finish") and every option is named
       "<Cut>, <gold plated|silver>", the finish becomes a two-way switch and only that
       finish's cuts show, each as a close-up tile of its setting. Same data, same bag,
       same variants: only which chips are visible changes. Anything that does not parse
       falls back to the ordinary grid. */
    var GROUP = root.getAttribute('data-group') === 'finish';
    if (GROUP) data.forEach(function (c) {
      var m = /^(.*?),\s*(gold plated|silver)\s*$/i.exec(String(c.name));
      if (m) { c.cut = m[1].replace(/^\s+|\s+$/g, ''); c.fin = m[2].toLowerCase(); } else GROUP = false;
    });

    var chips = [];
    if (swg) {
      swg.innerHTML = '';
      data.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'chip'; b.dataset.id = c.id;
        b.setAttribute('aria-label', c.name);
        /* Sold-out colours stay visible so the range still reads as six, but the
           chip is disabled and says so: `available` comes from the variant, so
           setting a variant's stock to zero (policy DENY) is the whole switch.
           Lukas, 2026-09-16: "make green out of stock, they see it's out of stock". */
        var oos = c.available === false;
        /* Restocking colours (2026-09-22): tracked stock at 0. Waitlist-only ones
           stay tappable so the shopper can see them and reach the email form, but
           a tap only previews - it never goes into the bag. Pre-order ones (policy
           CONTINUE, so available) behave like any colour and are labelled. */
        var waitOnly = c.restock === true && oos;
        b.innerHTML = '<span class="chipMat"><img alt="" src="' + (GROUP && c.tile ? c.tile : c.swatch) + '" loading="lazy">' +
                      '<span class="chipQ nm" data-cq>0</span></span>' +
                      '<span class="chipNm">' + (GROUP ? c.cut : chipName(c.name)) +
                      (c.preorder ? ' · Pre-order' : oos ? ' · Sold out' : '') + '</span>';
        if (waitOnly) {
          b.dataset.rs = '1';
          b.setAttribute('aria-label', c.name + ', sold out — join the waitlist');
          b.onclick = function () { view = i; touched = true; paint(); };
        } else if (oos) {
          b.disabled = true; b.dataset.oos = '1';
          b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-label', c.name + ', sold out');
        } else {
          b.onclick = function () {
            view = i;
            queue.push(i);
            if (queue.length > capN()) queue.shift();
            touched = true;
            paint();
          };
        }
        swg.appendChild(b); chips.push(b);
      });
    }

    /* The finish switch. Pressing it only PREVIEWS the same cut in the other finish and
       swaps which cuts are shown; nothing goes in the bag until a cut is tapped. The
       count on each side is how many of that finish are already in the bag. */
    var finEl = root.querySelector('[data-fin]'), finBtns = [];
    if (finEl && GROUP) {
      var FINS = [];
      data.forEach(function (c) { if (FINS.indexOf(c.fin) < 0) FINS.push(c.fin); });
      FINS.sort(function (a, b) { return (a === 'silver' ? 0 : 1) - (b === 'silver' ? 0 : 1); });
      FINS.forEach(function (f) {
        var fb = document.createElement('button');
        fb.type = 'button'; fb.className = 'fin'; fb.dataset.f = f;
        fb.setAttribute('role', 'radio');
        fb.innerHTML = '<i aria-hidden="true"></i><span>' + (f === 'silver' ? 'Silver' : 'Gold plated') +
                       '</span><span class="finQ nm" data-fq></span>';
        fb.onclick = function () {
          var cur = data[view], pick = -1, k;
          for (k = 0; k < data.length; k++) if (data[k].fin === f && cur && data[k].cut === cur.cut) { pick = k; break; }
          if (pick < 0) for (k = 0; k < data.length; k++) if (data[k].fin === f) { pick = k; break; }
          if (pick >= 0) { view = pick; touched = true; paint(); }
        };
        finEl.appendChild(fb); finBtns.push(fb);
      });
    } else if (finEl) finEl.hidden = true;

    /* ---- gallery ---- */
    var stageFor = -1, stageCache = {};
    function buildStage() {
      var want = view;
      if (!stage || stageFor === want) return;
      var target = want;
      stageFor = want;
      var trk = stage.querySelector('[data-trk]');
      if (!trk) return;
      var nodes;
      if (stageCache[target]) {
        nodes = stageCache[target];
      } else {
        var c = data[target];
        var frames = [{ src: c.image, cap: c.name, prod: 1 }].concat(
          (c.shots || []).map(function (s) { return { src: s.src, cap: s.cap }; }));
        /* 2026-10-20 (Lukas): back to product first: floating chain, shape close-up, on the wrist (1, 2, 3).
           The wrist-first order of 2026-10-07 is retired. */
        var tmp = document.createElement('div');
        tmp.innerHTML = frames.map(function (f, k) {
          /* The first frame is on screen the instant a colour is picked; leaving it
             lazy meant waiting on the intersection observer before it even began
             fetching, which reads as a blank flash. The rest stay lazy. */
          return '<div class="cel"><div class="fr' + (f.prod ? ' prod' : '') + '">' +
                 '<img alt="' + f.cap + '" src="' + f.src + '"' +
                 (k === 0 ? ' fetchpriority="high"' : ' loading="lazy"') + '></div></div>';
        }).join('');
        nodes = [].slice.call(tmp.children);
        stageCache[target] = nodes;
      }

      function swap() {
        /* a newer colour was tapped while this one decoded - drop this swap rather
           than flashing a frame the shopper has already moved past */
        if (stageFor !== target) return;
        /* THE cause of "the slider scrolls when I pick a colour": the track carries
           scroll-behavior:smooth, so assigning scrollLeft ANIMATED it back to frame
           one in full view. Suspend smooth scrolling and snapping for the swap. */
        var prevSnap = trk.style.scrollSnapType, prevBehav = trk.style.scrollBehavior;
        trk.style.scrollSnapType = 'none';
        trk.style.scrollBehavior = 'auto';
        var frag = document.createDocumentFragment();
        nodes.forEach(function (n) { frag.appendChild(n); });
        /* replaceChildren is Chrome 86 / Safari 14 and this file is otherwise ES5
           on purpose, so an older phone must not be left with a picker that throws. */
        if (trk.replaceChildren) trk.replaceChildren(frag);
        else { while (trk.firstChild) trk.removeChild(trk.firstChild); trk.appendChild(frag); }
        trk.scrollLeft = 0;
        trk.style.scrollSnapType = prevSnap || '';
        trk.style.scrollBehavior = prevBehav || '';
        var d = stage.querySelector('[data-dots]'); if (d) d.innerHTML = '';
        /* carousel() measures with getBoundingClientRect. Running it in the same
           task as the swap forces a synchronous layout on top of the paint already
           queued, which is the jolt you feel. Give it the next frame. */
        requestAnimationFrame(function () { carousel(stage); });
      }

      /* Decode BEFORE inserting. An undecoded image decodes on the main thread at
         insertion, inside the frame already doing the swap - that is the stutter.
         decode() moves it off-thread so the swap is only a pointer change. */
      var first = nodes[0] && nodes[0].querySelector('img');
      if (first && first.decode) first.decode().then(swap, swap);
      else swap();
    }

    /* Send a copy of the photograph to the bag. Transform and opacity only, so it
       is composited and cannot stall the click it is confirming. */
    function flyToBag() {
      /* Fly to the pill: it is bottom-right and always on screen, so it is both
         the nearer target and the one the eye is already on. The header bag is
         the fallback for any page that does not render the pill. */
      var target = document.querySelector('.pill') || document.querySelector('.hdBag');
      var src = stage && stage.querySelector('img');
      if (!target || !src || !src.complete) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var a = src.getBoundingClientRect(), b = target.getBoundingClientRect();
      if (!a.width || !b.width) return;
      var ghost = document.createElement('img');
      ghost.src = src.currentSrc || src.src;
      ghost.className = 'flyer';
      ghost.style.left = a.left + 'px'; ghost.style.top = a.top + 'px';
      ghost.style.width = a.width + 'px'; ghost.style.height = a.height + 'px';
      document.body.appendChild(ghost);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
      var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      requestAnimationFrame(function () {
        ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.08)';
        ghost.style.opacity = '0';
      });
      setTimeout(function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, 720);
      target.classList.remove('pulse');
      void target.offsetWidth;
      target.classList.add('pulse');
    }

    function paint() {
      var o = tier >= 0 ? offers[tier] : null;
      var n = capN();

      /* The numeral is how many of this colour are in the CHOICE being built. They
         sum to N, which is the only glanceable proof the bag is complete - so it
         shows at every count including 1, not just at 2+. */
      var cts = counts();
      chips.forEach(function (b, i) {
        var q = cts[i];
        var hv = q > 0 ? '1' : '0';
        if (b.dataset.has !== hv) b.dataset.has = hv;
        setText(b.querySelector('[data-cq]'), String(q));
        var sel = i === view ? '1' : '0';
        if (b.dataset.sel !== sel) b.dataset.sel = sel;
        b.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
        b.setAttribute('aria-label', data[i].name + ', ' + q + ' of ' + n + ' selected');
      });

      if (GROUP) {
        var cf = data[view].fin, fcount = {};
        chips.forEach(function (b, i) {
          var hide = data[i].fin !== cf;
          if (b.hidden !== hide) b.hidden = hide;
          fcount[data[i].fin] = (fcount[data[i].fin] || 0) + cts[i];
        });
        finBtns.forEach(function (fb) {
          var f = fb.dataset.f;
          fb.setAttribute('aria-checked', f === cf ? 'true' : 'false');
          setText(fb.querySelector('[data-fq]'), fcount[f] ? String(fcount[f]) : '');
        });
      }

      if (offersUI) [].forEach.call(offersUI.children, function (el, i) {
        var sel = i === tier ? '1' : '0';
        if (el.dataset.sel !== sel) el.dataset.sel = sel;
        el.setAttribute('aria-checked', i === tier ? 'true' : 'false');
      });

      setText(nameEl, data[view].name);
      setText(forEl, data[view].occasion || '');

      setText(hintEl, !o ? 'Pick your ' + WORD + 's, then choose how many below.'
                    : n === 1 ? (GROUP ? 'Choose a finish, then tap a cut.' : 'Tap the ' + WORD + ' you want.')
                    : GROUP ? 'Pick your ' + n + ': a finish, then a cut each. Tap twice for two the same.'
                    : 'Tap to pick your ' + n + ' — tap twice for two the same.');
      /* Space is always reserved, so showing it cannot shift the grid below. */
      if (resetEl) resetEl.style.visibility = queue.length ? 'visible' : 'hidden';
      /* Whatever is still unpicked gets the colour on screen. Saying so here is
         what stops that from being a surprise at the moment of commitment. */
      var short = n - queue.length, fill = data[fillIdx()];
      /* Pre-order colours in the bag are named once, with the date, right where the
         shopper commits - the ship date must be seen before paying. */
      var preNames = [], seenPre = {};
      queue.concat(short > 0 ? [fillIdx()] : []).forEach(function (k) {
        if (data[k] && data[k].preorder && !seenPre[k]) { seenPre[k] = 1; preNames.push(data[k].name); }
      });
      var preNote = preNames.length
        ? '<br><span class="rsNote">' + preNames.join(' and ') + ' will take a bit longer: we’re waiting on our restock' +
          (RDATE ? ' (expected ' + RDATE + ')' : '') + ' and ship ' + (preNames.length === 1 ? 'it' : 'them') + ' the day ' + (preNames.length === 1 ? 'it arrives' : 'they arrive') + '.</span>'
        : '';
      setHTML(readEl, (!o
        ? (queue.length ? mix() : '')
        : !queue.length
          ? (orderable(view) ? 'Nothing picked' : data[view].name + ' is sold out') + ' — Add gives <b>' + n + '× ' + fill.name + '</b>'
          : mix() + (short > 0 ? ' <i>+' + short + '× ' + fill.name + '</i>' : '')) + preNote);

      if (rsBox) {
        var rc = data[view];
        rsBox.hidden = !rc.restock;
        if (rc.restock) {
          setHTML(rsHead, '<b>' + rc.name + (RDATE ? ' is expected back ' + RDATE : ' is back soon') + '.</b>');
          setText(rsPre, rc.preorder
            ? 'You can still order it today, same price and same deal. It will take a bit longer to reach you because we’re waiting on our restock, and we ship it the day it arrives. Or leave your email and we’ll tell you when it’s in.'
            : 'Leave your email and we’ll tell you the moment it’s in.');
        }
      }

      if (addBtn) {
        addBtn.disabled = !o;
        setHTML(addBtn, o
          ? 'Add ' + n + ' to cart <span class="q nm">' + money(payCents(o)) + '</span>'
          : 'Choose an option');
      }

      buildStage();
    }

    /* Warm every colour's first frame once the page is idle, so the first tap on a
       colour is a decode of something already cached rather than a network wait. */
    var warm = function () {
      data.forEach(function (c) {
        /* the frame that leads the gallery: the product photo */
        var lead = c.image;
        if (lead) { var im = new Image(); im.src = lead; }
      });
      /* The other finish's cut tiles are hidden until the switch is pressed, so the browser
         never fetches them by itself: fetch them now, or the first switch flashes blank. */
      if (GROUP) data.forEach(function (c) { if (c.tile) { var ti = new Image(); ti.src = c.tile; } });
    };
    if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 1200);

    if (addBtn) addBtn.onclick = function () {
      if (tier < 0) return;
      var o = offers[tier], n = totalOf(o);
      /* One line per distinct colour. The queue already holds exactly N, so there is
         nothing to top up and no partial case to handle. Every bracelet is added at
         FULL price - the automatic discount is what makes the free ones free, and it
         is scoped to the product, so a split across lines still earns it. */
      var q = queue.slice(), z;
      while (q.length < n) q.push(fillIdx());
      var cts = [], items = [];
      for (z = 0; z < data.length; z++) cts.push(0);
      for (z = 0; z < q.length; z++) cts[q[z]]++;
      for (z = 0; z < cts.length; z++) {
        if (cts[z] > 0) items.push({ id: data[z].variant, quantity: cts[z] });
      }
      if (!items.length) return;
      flyToBag();
      /* Open first, fetch second. The 300ms of popup animation is exactly the
         window the request needs - waiting for the response before opening is
         what read as lag. */
      var MC = window.MossanteCart;
      if (MC) MC.open();
      addBtn.disabled = true; addBtn._h = null; addBtn.textContent = 'Adding…';
      /* Through the cart's one serialized queue, never beside it: a direct
         /cart/add.js raced the drawer's steppers (audit C6). The direct call is
         only for a page where the cart script failed to load - no queue exists
         there to race. */
      (MC && MC.add ? MC.add(items) : req('/cart/add.js', { items: items }).then(function (r) {
          /* no cart script on this page (not uploaded to the published theme,
             a CDN miss): there is no drawer to show the Add, so go to Shopify's
             own cart page, which still checks out (review R6) */
          window.location.href = '/cart';
          return r;
        }))
        .then(function () {
          clear(); touched = false;
          paint();
        })
        .catch(function (e) {
          addBtn.disabled = false; addBtn._h = null;
          addBtn.textContent = (e && e.description) ? e.description : 'Could not add — try again';
        });
    };

    if (resetEl) resetEl.onclick = function () { clear(); touched = false; paint(); };

    paint();

  }

  /* ---------- cart drawer ----------
     Lives in assets/mossante-cart.js (2026-09-23): ONE drawer and ONE write
     queue for every template, loaded before this file. Never add cart code
     here again - two copies drifted apart once (audit C1-C6). */

  /* ---------- announcement bar ---------- */
  function anno(el) {
    var k = el.children;
    if (k.length < 2) return;
    var i = 0;
    setInterval(function () {
      k[i].classList.remove('on'); i = (i + 1) % k.length; k[i].classList.add('on');
    }, 3800);
  }

  /* The header stays for the brand but gives the words back: past 40px of
     scroll it compacts, and returns to full size at the top. rAF-throttled and
     class-toggled only, so the scroll itself never does layout work. */
  function headerShrink() {
    var hd = document.querySelector('[data-hd]');
    if (!hd) return;
    var mini = false, tick = false;
    var judge = function () {
      tick = false;
      /* while the cart popup pins the body, scroll reads 0 - do not un-mini
         the header behind the scrim only to snap it back on close */
      if (document.body.style.position === 'fixed') return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      /* hysteresis: shrink past 64, restore only near the very top, so the
         header never flutters around a single threshold pixel */
      var want = y > 64 ? true : (y < 16 ? false : mini);
      if (want !== mini) { mini = want; hd.classList.toggle('hdMini', want); }
    };
    addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(judge); }
    }, { passive: true });
    judge();
  }

  function init(scope) {
    scope = scope || document;
    if (!init._hd) { init._hd = 1; headerShrink(); }
    scope.querySelectorAll('[data-car]').forEach(carousel);
    scope.querySelectorAll('[data-picker]').forEach(picker);
    scope.querySelectorAll('[data-anno]').forEach(anno);
    reveals();
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  /* The bag and the pill open the drawer in mossante-cart.js. If that script is
     missing, a bag tap would do nothing on every page: send it to /cart. */
  document.addEventListener('click', function (e) {
    if (window.MossanteCart) return;
    var t = e.target && e.target.closest ? e.target.closest('[data-open-cart]') : null;
    if (t) { if (e.preventDefault) e.preventDefault(); window.location.href = '/cart'; }
  });
  /* the theme editor re-renders sections in place */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
